// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 9999;
    gap: 10px;
}

.loader-overlay div {
    width: fit-content;
    font-weight: bold;
    font-size: 30px;
    direction: rtl;
    unicode-bidi: embed;
    display: flex;
    align-items: center;
}

.loader-overlay div:before {
    content: "لطفا منتظر بمانید";
}

.loader-overlay div:after {
    content: "…";
    display: inline-block;
    width: 1.5ch;
    text-align: right;
    overflow: hidden;
    animation: dots 2s steps(3) infinite;
}

@keyframes dots {
    0% { content: ""; }
    33% { content: "."; }
    66% { content: ".."; }
    100% { content: "..."; }
}

.loader {
    width: 100px;
    height: 100px;
    animation: spin-pulse 2s ease-in-out infinite, color-change 3s linear infinite;
}

@keyframes spin-pulse {
    0% {
        transform: rotate(0deg) scale(1);
    }
    50% {
        transform: rotate(180deg) scale(1.2);
    }
    100% {
        transform: rotate(360deg) scale(1);
    }
}

@keyframes color-change {
    0% {
        filter: hue-rotate(0deg);
    }
    50% {
        filter: hue-rotate(180deg);
    }
    100% {
        filter: hue-rotate(360deg);
    }
}

.locked {
    opacity: 0.5;
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Loading/Loading.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,KAAK,WAAW,EAAE;IAClB,MAAM,YAAY,EAAE;IACpB,MAAM,aAAa,EAAE;IACrB,OAAO,cAAc,EAAE;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8EAA8E;AAClF;;AAEA;IACI;QACI,gCAAgC;IACpC;IACA;QACI,oCAAoC;IACxC;IACA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":[".loader-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.3);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    z-index: 9999;\n    gap: 10px;\n}\n\n.loader-overlay div {\n    width: fit-content;\n    font-weight: bold;\n    font-size: 30px;\n    direction: rtl;\n    unicode-bidi: embed;\n    display: flex;\n    align-items: center;\n}\n\n.loader-overlay div:before {\n    content: \"لطفا منتظر بمانید\";\n}\n\n.loader-overlay div:after {\n    content: \"…\";\n    display: inline-block;\n    width: 1.5ch;\n    text-align: right;\n    overflow: hidden;\n    animation: dots 2s steps(3) infinite;\n}\n\n@keyframes dots {\n    0% { content: \"\"; }\n    33% { content: \".\"; }\n    66% { content: \"..\"; }\n    100% { content: \"...\"; }\n}\n\n.loader {\n    width: 100px;\n    height: 100px;\n    animation: spin-pulse 2s ease-in-out infinite, color-change 3s linear infinite;\n}\n\n@keyframes spin-pulse {\n    0% {\n        transform: rotate(0deg) scale(1);\n    }\n    50% {\n        transform: rotate(180deg) scale(1.2);\n    }\n    100% {\n        transform: rotate(360deg) scale(1);\n    }\n}\n\n@keyframes color-change {\n    0% {\n        filter: hue-rotate(0deg);\n    }\n    50% {\n        filter: hue-rotate(180deg);\n    }\n    100% {\n        filter: hue-rotate(360deg);\n    }\n}\n\n.locked {\n    opacity: 0.5;\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
